class PriceRegionController extends AbstractEntityEditController
	@register()
	@inject 'translate',
		'$uibModal'
		'$scope'
		'currencies'
		'priceRegion'
		'vatRates'
		'ConfigurationService'
		'PriceRegionRepository'
		'VatRateRepository'
		'ToastService'
		'MessageTerminal'
		'MessageTypes'
		'BACKEND_VAT_RATE_DATA_ENTITY_TYPE'
		'UserInformation'

	initialize: ->
		@mainCrud.entityType = 'general.price.region'
		@mainCrud.parent_form.$setPristine()
		@mainCrud.saving = false

		@vatRateDataEntityTypes = _.without(@BACKEND_VAT_RATE_DATA_ENTITY_TYPE, 'DefaultToStayVatRate')
		@isToStayToGoEnabled = @ConfigurationService.isEnabled 'Backoffice.Permission.ToGoToStay.Enabled'
		@isVatRateEnabled = @ConfigurationService.isEnabled 'Shared.Setting.VatRate.Enabled'

		@vatRateList = @processTaxes @vatRates
		@defaultVatRateType = @BACKEND_VAT_RATE_DATA_ENTITY_TYPE.NORMAL

		@relevantVatRateEntityTypes = @getRelevantVatRateEntityTypes()

		if @priceRegion.id?
			@mainCrud.entityTitle = @priceRegion.name
			@mainCrud.isNewEntity = false
			@mainCrud.showDelete = @UserInformation.getMasterUser().price_region_id != @priceRegion.id
		else
			@mainCrud.isNewEntity = true
			@priceRegion =
				currency_add_on_factor: 1
				default_vat_rate_id: null
				vat_rate_data: []

			@mainCrud.entityTitle =  'wbo.price_region.title.new'
			@mainCrud.showSave = @ConfigurationService.isEnabled "Backoffice.Permission.PriceRegionCreation.Enabled"

		@initializeVatRateDataTypes()

	save: ->
		@mainCrud.saving = true

		priceRegion = @beforeSave()

		@PriceRegionRepository
			.save priceRegion, @mainCrud.isNewEntity
			.then (response) =>
				@afterSave response
			.catch (response) =>
				@handleErrors response.data

	delete: ->
		@deleteEntity @PriceRegionRepository, @priceRegion

	beforeSave: ->
		priceRegion = angular.copy @priceRegion

		defaultVatRate = _.find priceRegion.vat_rate_data, {entity_type: @defaultVatRateType}

		if angular.isDefined defaultVatRate
			priceRegion.default_vat_rate_id = defaultVatRate.vat_rate_id

		priceRegion.vat_rate_data = _.reject priceRegion.vat_rate_data, {vat_rate_id: null}

		return priceRegion

	initializeVatRateDataTypes: ->
		if !@isVatRateEnabled
			return

		angular.forEach @getRelevantVatRateEntityTypes(), (entityType) =>
			isNew = true

			if angular.isDefined @priceRegion.id
				isNew = angular.isUndefined(_.find(@priceRegion.vat_rate_data, {entity_type: entityType}))

			if isNew
				taxData = {}
				taxData.entity_type = entityType
				taxData.vat_rate_id = null

				if entityType == @defaultVatRateType
					taxData.vat_rate_id = @priceRegion.default_vat_rate_id

				@priceRegion.vat_rate_data.push taxData

	showInfoModal: ->
		@$uibModal.open templateUrl: '@app/price-region/price-region.modal.view.html'

	processTaxes: (taxesData) ->
		taxes = []

		angular.forEach taxesData, (taxData) =>
			tax =
				id: taxData.id
				data: taxData
				percentage: @VatRateRepository.getPercentageText(taxData.percentage) + '%'

			tax.name = if taxData.name then tax.percentage + ' ' + taxData.name else tax.percentage
			taxes.push tax

		return taxes

	getRelevantVatRateEntityTypes: ->
		if !@isVatRateEnabled
			return []

		if @isToStayToGoEnabled
			return @vatRateDataEntityTypes

		return ['DefaultNormalVatRate']

	getTaxDataWithEntityType: (entityType, data) ->
		return _.find data, {entity_type: entityType}
